import { memo } from 'react';

import { FiltersModal } from '../../filters';
import { RequestFormModal, RequestFormSpacesModal, RequestSendSuccessModal } from '../../requestModals';
import SujetCheckPopupModal from '../../sujetCheckPopupModal';
import { CollectionModal } from '../collection';

const Modals = () => (
    <>
        <RequestFormModal />
        <RequestFormSpacesModal />
        <RequestSendSuccessModal />
        <CollectionModal />
        <FiltersModal />
        <SujetCheckPopupModal />
    </>
);

export default memo(Modals);
